exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-links-list[data-v-85fbebb0]{list-style:none;margin:10px 0 0;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex}.social-media-item[data-v-85fbebb0]{margin-right:20px}.social-media-item[data-v-85fbebb0]:last-child{margin-right:0}.social-media-link[data-v-85fbebb0]{color:#10284a}.social-media-link[data-v-85fbebb0]:hover{color:#e8b88b}", ""]);

// exports
